// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c6c9ab7c","952":"a2e6a997"}[chunkId] + ".chunk.js";
};